import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { noAuthGuard } from './auth/guards/no-auth.guard';
import { authGuard } from './auth/guards/auth.guard';
import { GolfDigestLoginLayoutComponent } from './layout/golf-digest-login-layout/golf-digest-login-layout.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { AuthComponent } from './modules/auth/auth.component';
import { OnCourseComponent } from './modules/golf-on-course/on-course/on-course.component';
import { InPlayComponent } from './modules/golf-on-course/in-play/in-play.component';
import { OnCourseLayoutComponent } from './modules/golf-on-course/on-course-layout/on-course-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./modules/landing/landing.component').then((m) => m.LandingComponent)
      },
      {
        path: 'discover',
        loadChildren: () =>
          import('./modules/leader-board/leader-board.route').then((m) => m.ROUTES)
      },
      {
        path: 'settings/user-settings',
        loadChildren: () =>
          import('./modules/settings/settings.route').then(
            (m) => m.SettingsRoutes
          ),
        canActivate: [authGuard]
      },
      {
        path: 'play-golf',
        pathMatch: 'full',
        component: OnCourseComponent,
        canActivate: [authGuard],
      },
      {
        path: 'tee-times',
        loadChildren: () =>
          import('./modules/tee-times/tee-times.routes').then(m => m.ROUTES),
        canActivate: [authGuard],
      },
      {
        path: 'video-wall',
        pathMatch: 'full',
        loadComponent: () =>
          import('./modules/video-wall/video-wall.component').then((m) => m.VideoWallComponent),
      },
      {
        path: 'video-wall/preview/:id',
        loadComponent: () =>
          import('./modules/video-wall/video-preview/video-preview.component').then((m) => m.VideoPreviewComponent),
      },
      {
        path: 'article',
        loadChildren: () =>
          import('./modules/article/article.routes').then((m) => m.ROUTES),
      },
    ],
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/auth/auth.route').then((m) => m.AuthRoutes),
        canActivate: [noAuthGuard],
      },
    ],
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/public/pubic.route').then((m) => m.PublicRoutes),
  },
  {
    path: 'embed',
    loadChildren: () =>
      import('./modules/leader-board/leader-board.route').then((m) => m.ROUTES)
  },
  {
    path: 'in-play',
    canActivate: [authGuard],
    component: OnCourseLayoutComponent,
    children: [
      {
        path: ':id',
       component: InPlayComponent
      },
    ],
  },
  {
    path: 'concierge',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/voice-eleven-sdk/voice-eleven-sdk.route').then(
        (m) => m.VoiceElevenSdkRoutes
      ),
  },
  // Golf Digest login layout
  {
    path: 'golf-digest',
    component: GolfDigestLoginLayoutComponent,
    children: [
      {
        path: '',
        component: AuthComponent,
        loadChildren: () =>
          import('./modules/auth/auth.route').then((m) => m.AuthRoutes),
        canActivate: [noAuthGuard],
      },
    ],
  },
  {
    path: 'error/404',
    component: PageNotFoundComponent
  },
  { path: '**', redirectTo: '' }
];
